import { ActionFunction } from '../interface/action/action-function.type';
import { IRoutePayload } from '../interface/action/route-payload.interface';
import { ActionEnum } from '../enum/action.enum';
import { action } from 'mobx';

export const initialize$: ActionFunction<IRoutePayload> = (action$, {state}) => {
  return action$
    .type(ActionEnum.INITIALIZE)
    .end(action((route: IRoutePayload) => {
      state.currentPath = route.location.pathname;
    }));
};

export default {
  actions: [ initialize$ ]
};
